export function IconCalculator({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <rect x="5" y="3" width="14" height="18" rx="2" />
      <path d="M8 7H16" strokeLinecap="round" />
      <path d="M8 11H10" strokeLinecap="round" />
      <path d="M12 11H14" strokeLinecap="round" />
      <path d="M16 11H16.01" strokeLinecap="round" />
      <path d="M8 15H10" strokeLinecap="round" />
      <path d="M12 15H14" strokeLinecap="round" />
      <path d="M16 15H16.01" strokeLinecap="round" />
    </svg>
  );
}

export function IconPriceTag({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M4 4H11L20 13L13 20L4 11V4Z" strokeLinejoin="round" />
      <circle cx="8" cy="8" r="1.4" fill="currentColor" stroke="none" />
      <path d="M13.5 10.5C13 10 12 10 11.5 10.5C11 11 11 11.6 11.7 12L13 12.6C13.7 13 13.7 13.6 13.2 14.1C12.7 14.6 11.7 14.6 11.2 14.1" strokeLinecap="round" />
    </svg>
  );
}

export function IconChart({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M4 19V5" strokeLinecap="round" />
      <path d="M4 19H20" strokeLinecap="round" />
      <path d="M8 15V11" strokeLinecap="round" />
      <path d="M12 15V7" strokeLinecap="round" />
      <path d="M16 15V9" strokeLinecap="round" />
    </svg>
  );
}

export function IconOrders({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M7 7H17L19 11V19H5V11L7 7Z" strokeLinejoin="round" />
      <path d="M9 11H15" strokeLinecap="round" />
    </svg>
  );
}

export function IconProcurement({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M6 6H18V18H6V6Z" strokeLinejoin="round" />
      <path d="M9 10H15" strokeLinecap="round" />
      <path d="M9 14H13" strokeLinecap="round" />
    </svg>
  );
}

export function IconInventory({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M4 8L12 4L20 8V16L12 20L4 16V8Z" strokeLinejoin="round" />
      <path d="M12 12L20 8" />
      <path d="M12 12V20" />
      <path d="M12 12L4 8" />
    </svg>
  );
}

export function IconInvoice({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M8 4H16L19 7V20H5V4H8Z" strokeLinejoin="round" />
      <path d="M8 4V7H16" />
      <path d="M9 12H15" strokeLinecap="round" />
      <path d="M9 16H13" strokeLinecap="round" />
    </svg>
  );
}

export function IconReport({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M6 3H14L18 7V21H6V3Z" strokeLinejoin="round" />
      <path d="M14 3V7H18" strokeLinejoin="round" />
      <path d="M9 12H15" strokeLinecap="round" />
      <path d="M9 16H15" strokeLinecap="round" />
      <path d="M9 8H11" strokeLinecap="round" />
    </svg>
  );
}

export function IconSettings({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <circle cx="12" cy="12" r="3" />
      <path d="M12 3V5" strokeLinecap="round" />
      <path d="M12 19V21" strokeLinecap="round" />
      <path d="M3 12H5" strokeLinecap="round" />
      <path d="M19 12H21" strokeLinecap="round" />
    </svg>
  );
}

export function IconHome({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M4 10.5L12 4L20 10.5V19H4V10.5Z" strokeLinejoin="round" />
      <path d="M10 19V13H14V19" />
    </svg>
  );
}

export function IconProducts({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M6 8L12 4L18 8V16L12 20L6 16V8Z" strokeLinejoin="round" />
      <path d="M9 10H15" strokeLinecap="round" />
      <path d="M9 14H13" strokeLinecap="round" />
    </svg>
  );
}

export function IconUnshipped({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M4 7H18L20 11V19H4V7Z" strokeLinejoin="round" />
      <path d="M4 11H20" strokeLinecap="round" />
      <circle cx="8" cy="19" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="16" cy="19" r="1.5" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function IconFulfillment({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M3 7L12 3L21 7V17L12 21L3 17V7Z" strokeLinejoin="round" />
      <path d="M12 12L21 7" strokeLinecap="round" />
      <path d="M12 12V21" strokeLinecap="round" />
      <path d="M12 12L3 7" strokeLinecap="round" />
      <path d="M8 14.5L11 16.5L16 12" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconClose({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M7 7L17 17" strokeLinecap="round" />
      <path d="M17 7L7 17" strokeLinecap="round" />
    </svg>
  );
}

export function IconMoreVertical({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor">
      <circle cx="12" cy="5" r="1.6" />
      <circle cx="12" cy="12" r="1.6" />
      <circle cx="12" cy="19" r="1.6" />
    </svg>
  );
}

export function IconUser({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5 20C5.8 16.7 8.6 15 12 15C15.4 15 18.2 16.7 19 20" strokeLinecap="round" />
    </svg>
  );
}

export function IconPalette({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M12 3C7.6 3 4 6.4 4 10.8C4 14.6 6.8 17.5 10.5 17.5H11.2C11.9 17.5 12.5 18.1 12.5 18.8C12.5 19.8 11.7 20.5 10.7 20.5C9.4 20.5 8.5 19.8 8 18.8" strokeLinecap="round" />
      <circle cx="8.5" cy="9.5" r="1" fill="currentColor" stroke="none" />
      <circle cx="12" cy="7" r="1" fill="currentColor" stroke="none" />
      <circle cx="15.5" cy="9.5" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function IconKey({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <circle cx="8" cy="12" r="3.5" />
      <path d="M11 12H20V14" strokeLinecap="round" />
      <path d="M17 12V16" strokeLinecap="round" />
    </svg>
  );
}

export function IconEmpty({ className = 'h-16 w-16' }) {
  return (
    <svg className={className} viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="10" y="14" width="44" height="36" rx="4" />
      <path d="M22 28H42" strokeLinecap="round" />
      <path d="M22 36H36" strokeLinecap="round" />
    </svg>
  );
}

export function IconLink({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M10 13a3 3 0 0 0 4.24 0l3-3a3 3 0 1 0-4.24-4.24l-1 1" strokeLinecap="round" />
      <path d="M14 11a3 3 0 0 0-4.24 0l-3 3a3 3 0 1 0 4.24 4.24l1-1" strokeLinecap="round" />
    </svg>
  );
}

export function IconShield({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M12 3L20 7V12C20 16.4 16.8 19.7 12 21C7.2 19.7 4 16.4 4 12V7L12 3Z" strokeLinejoin="round" />
      <path d="M9 12L11 14L15 10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconCalendar({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <rect x="4" y="5" width="16" height="15" rx="2" />
      <path d="M8 3V7" strokeLinecap="round" />
      <path d="M16 3V7" strokeLinecap="round" />
      <path d="M4 10H20" strokeLinecap="round" />
    </svg>
  );
}

export function IconClock({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <circle cx="12" cy="12" r="8" />
      <path d="M12 8V12L15 14" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconBell({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path
        d="M18 16V11C18 7.686 15.314 5 12 5C8.686 5 6 7.686 6 11V16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5 16H19" strokeLinecap="round" />
      <path d="M10 19C10.5 20 11.5 20.5 12 20.5C12.5 20.5 13.5 20 14 19" strokeLinecap="round" />
    </svg>
  );
}

export function IconChevronRight({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M9 6L15 12L9 18" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconChevronLeft({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M15 6L9 12L15 18" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconLogout({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M10 7V5C10 4.4 10.4 4 11 4H19C19.6 4 20 4.4 20 5V19C20 19.6 19.6 20 19 20H11C10.4 20 10 19.6 10 19V17" strokeLinecap="round" />
      <path d="M15 12H4M4 12L7 9M4 12L7 15" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconSearch({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <circle cx="11" cy="11" r="6.5" />
      <path d="M16.5 16.5L20 20" strokeLinecap="round" />
    </svg>
  );
}

export function IconUpload({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M12 16V5" strokeLinecap="round" />
      <path d="M8 8.5L12 4.5L16 8.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 16.5V18.5C5 19.3 5.7 20 6.5 20H17.5C18.3 20 19 19.3 19 18.5V16.5" strokeLinecap="round" />
    </svg>
  );
}

export function IconMail({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <rect x="3" y="6" width="18" height="12" rx="2" />
      <path d="M3 8L12 13L21 8" strokeLinejoin="round" />
    </svg>
  );
}

export function IconPhone({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M7 4H10L11.5 8.5C11.7 9.1 11.5 9.7 11 10.1L9.3 11.5C10.5 14 12 15.5 14.5 16.7L15.9 15C16.3 14.5 16.9 14.3 17.5 14.5L22 16V19C22 19.6 21.6 20 21 20C11.6 20 4 12.4 4 3C4 2.4 4.4 2 5 2H8L9.5 6.5" strokeLinejoin="round" />
    </svg>
  );
}
